import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import { gridMargin } from './general';

import CarrierContainer from '../../containers/logistics/Carriers';

class FMPCarrierSelect extends PureComponent {
	componentDidMount() {
		const { carriers, searchCarriers } = this.props;
		if (_.isEmpty(carriers)) {
			searchCarriers({ params: {} });
		}
	}

	render() {
		const { label, value, path, onChange, carriers, error, helpText, md, contained } = this.props;

		const hasError = !!error;
		const _onChange = (event) => {
			onChange(event.target.value, path);
		};

		let content;
		if (_.isEmpty(carriers)) {
			content = (
				<Grid item xs={12} md={md} style={gridMargin}>
					<FormControl fullWidth={true} error={hasError}>
						Getting carriers....
					</FormControl>
				</Grid>
			);
		} else {
			content = (
				<Grid item xs={12} md={md} style={gridMargin}>
					<FormControl fullWidth={true} error={hasError}>
						<InputLabel htmlFor={path}>{label}</InputLabel>
						<Select value={value} onChange={_onChange} input={<Input id={path} />}>
							{_.sortBy(carriers, 'name').map((carrier, i) => {
								return (
									<MenuItem key={i} value={carrier.carrierId}>
										{carrier.name}
									</MenuItem>
								);
							})}
						</Select>
						{hasError && <FormHelperText>{error}</FormHelperText>}
						{helpText && !hasError && <FormHelperText>{helpText}</FormHelperText>}
					</FormControl>
				</Grid>
			);
		}

		if (contained) {
			return (
				<Grid spacing={2} container>
					{content}
				</Grid>
			);
		} else {
			return content;
		}
	}
}

FMPCarrierSelect.propTypes = {
	label: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	path: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	error: PropTypes.string,
	contained: PropTypes.bool,

	searchCarriers: PropTypes.func,
	carriers: PropTypes.array,
	md: PropTypes.number,
	helpText: PropTypes.string,
};

FMPCarrierSelect.defaultProps = {
	label: 'Carrier',
	contained: true,
	md: 12,
};

export default _.flow([CarrierContainer])(FMPCarrierSelect);
